export default "__VITE_ASSET__Dwk1SHxD__"